import { useTranslation } from "react-i18next";
import TogglePeriod from "./components/Toggle";
import useBreakpoints from "@hooks/useBreakPoinst";
import { useRTL } from "@hooks/useIsRTL";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const PriceLoader = () => (
  <Skeleton
    style={{ marginTop: 10 }}
    height={10}
    width={50}
    borderRadius={10}
  />
);
import {
  PageContainer,
  ContentContainer,
  ToggleContainer,
  Divider,
  StyledLeftArrow,
  StyledRightArrow,
  SubscriptionCard,
  OrderSection,
  TitleRow,
  PackageTitle,
  ChangeLink,
  RenewalNote,
  SummaryHeading,
  SummaryInfo,
  PropertiesSection,
  SummaryRow,
  TotalRow,
  SubscribeButtonWrapper,
  SubscribeButton,
  FooterNote,
} from "./styles";
import { useNavigate, useParams } from "react-router-dom";
import { useSubscription } from "@services";

import { useEffect, useState } from "react";

interface SubscriptionCardData {
  subscriptionPlanId: string;
  packageName: string;
  packageWithsFeature: {
    features: string[];
  }[];
  priceForEachProperty: string;
  priceForEachPropertyBeforeDiscount: string;
}

const ChoosePlanDetails = () => {
  const { t } = useTranslation();
  const { isPhone } = useBreakpoints();
  const { isRTL } = useRTL();
  const { id, period } = useParams();
  const [subscriptionType, setSubscriptionType] = useState<
    "Yearly" | "Monthly"
  >(period as "Yearly" | "Monthly");
  const navigate = useNavigate();
  const {
    getSubscriptionDataQuery,
    getActiveSubscriptionQuery,
    getSelectedSubscriptionCalculationQuery,
  } = useSubscription();

  const { data: activeSubscription } = getActiveSubscriptionQuery();

  const { data: subscriptionData = [], isLoading } = getSubscriptionDataQuery(
    1,
    period as string
  ) as {
    data: SubscriptionCardData[];
    isLoading: boolean;
  };
  const packageName = subscriptionData?.find(
    (pkg) => pkg.subscriptionPlanId == id
  )?.packageName;

  const {
    data: selectedCalculation,
    isLoading: isCalculationLoading,
    refetch,
    isRefetching,
  } = getSelectedSubscriptionCalculationQuery(
    `${id}&subscriptionType=${subscriptionType.toLowerCase()}` as string
  );

  useEffect(() => {
    refetch();
  }, [subscriptionType]);

  const handleCardPress = () => {
    navigate(`/choose-plan/${id}/${subscriptionType}/payment`);
  };

  const checkoutResult = selectedCalculation?.data?.result;
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "#fbfbfc",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <PageContainer $isPhone={isPhone}>
        <ContentContainer $isPhone={isPhone}>
          <SubscriptionCard $isPhone={isPhone}>
            {/* Toggle */}
            <ToggleContainer $isPhone={isPhone}>
              <TogglePeriod
                subscriptionType={subscriptionType}
                onChange={setSubscriptionType}
              />
            </ToggleContainer>

            {/* Order Info */}
            <OrderSection>
              <TitleRow $isPhone={isPhone}>
                <PackageTitle>{packageName}</PackageTitle>
                <ChangeLink
                  onClick={() => {
                    navigate("/choose-plan");
                  }}
                >
                  {t("chooseSubscription.changePackage")}
                </ChangeLink>
              </TitleRow>
              <RenewalNote>تتجدد بشكل تلقائي في تاريخ 13/01/2025</RenewalNote>
            </OrderSection>
            {/* Summary */}
            <SummaryHeading>
              {t("chooseSubscription.orderSummary")}
            </SummaryHeading>
            <SummaryInfo>
              <Divider />
              <PropertiesSection $isPhone={isPhone}>
                <span>
                  <span>{t("chooseSubscription.numberOfPropertiesAdded")}</span>
                  <span>{checkoutResult?.numberOfSeat}</span>
                </span>
                <span>
                  {t("chooseSubscription.propertiesAddedDuringTrial")}
                </span>
              </PropertiesSection>
            </SummaryInfo>

            <SummaryRow>
              <span style={{ fontSize: !isRTL && isPhone ? "12px" : "16px" }}>
                {t("chooseSubscription.propertyAdditionValue")}
              </span>
              {isCalculationLoading || isRefetching ? (
                <PriceLoader />
              ) : (
                <span>
                  {`${checkoutResult?.amountPerProperty} ر.س/${subscriptionType === "Monthly" ? t("chooseSubscription.monthly") : t("chooseSubscription.yearly")}`}
                </span>
              )}
            </SummaryRow>

            <TotalRow>
              <span>{t("chooseSubscription.finalTotal")}</span>
              {isCalculationLoading || isRefetching ? (
                <PriceLoader />
              ) : (
                <span>{`${checkoutResult?.totalNextPayment} ${t("COMMON.RS")}`}</span>
              )}
            </TotalRow>

            <SubscribeButtonWrapper>
              <SubscribeButton onClick={handleCardPress}>
                {t("chooseSubscription.subscribeNow")}
                {isRTL ? <StyledLeftArrow /> : <StyledRightArrow />}
              </SubscribeButton>
            </SubscribeButtonWrapper>

            <FooterNote>
              {t("chooseSubscription.changePlanAnytime")}
              <br />
              {t("chooseSubscription.termsAndConditions")}
            </FooterNote>
          </SubscriptionCard>
        </ContentContainer>
      </PageContainer>
    </div>
  );
};

export default ChoosePlanDetails;
